import clsx from 'clsx'
import React from 'react'

type Props = {
  onClick: () => void
}

export const ClearButton = ({ onClick }: Props) => {
  return <Button onClick={onClick}>Clear</Button>
}

const Button = ({ className, ...props }: React.ComponentPropsWithoutRef<'button'>) => (
  <button
    {...props}
    className={clsx('bg-action-accent text-red-300 hover:text-text-tertiary !text-center text-sm', className)}
    style={{ paddingBottom: '0.75rem' }}
  />
)
